<template>
  <span>
    <span v-for="index in fullStarCount" :key="'fullCount' + index">
      <full-star></full-star>
    </span>
    <span v-for="index in halfStarCount" :key="'halfCount' + index">
      <half-star></half-star>
    </span>
    <span v-for="index in emptyStarCount" :key="'emptyCount' + index">
      <empty-star></empty-star>
    </span>
  </span>
</template>

<script>
import FullStar from '@/assets/svg/common/star/ic_star_f.svg'
import HalfStar from '@/assets/svg/common/star/ic_star_h.svg'
import EmptyStar from '@/assets/svg/common/star/ic_star_off.svg'

export default {
  name: 'StartRating',
  props: ['rating'],
  components: {
    FullStar,
    HalfStar,
    EmptyStar
  },
  data () {
    return {
      fullStarCount: 0,
      halfStarCount: 0,
      emptyStarCount: 10
    }
  },
  mounted () {
    const curRating = Number(this.rating) / 2
    const fullStarCount = Math.floor(curRating)
    const halfStarCount = curRating - fullStarCount >= 0.25 ? 1 : 0
    const emptyStarCount = 5 - fullStarCount - halfStarCount
    this.fullStarCount = fullStarCount
    this.halfStarCount = halfStarCount
    this.emptyStarCount = emptyStarCount
  }

}
</script>
